<script setup></script>

<template>
  <div class="quote--alert-primary" role="alert">
    All pricing provided in this quote is valid for 30 days from the date of issue. After this period, 
    pricing is subject to change without notice and may be adjusted based on market conditions, supplier 
    costs, or other factors.
  </div>
</template>